import { Directive, HostListener } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors } from '@angular/forms';

@Directive({
  standalone: true,
  selector: '[appAmountValidator]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: AmountValidatorDirective, multi: true }
  ]

})
export class AmountValidatorDirective {

   private readonly validPattern = /^[0-9]*\.?[0-9]*$/; // Allows numbers and optional single decimal point
  private readonly urlPattern = /^(http|https|ftp):\/\/[^\s/$.?#].[^\s]*$/i; // Basic URL pattern

  validate(control: AbstractControl): ValidationErrors | null {
    const value = control.value ? String(control.value).trim() : '';

    if (!value) {
      return null; // Let required validator handle empty input
    }

    // Check for invalid characters (alphabets, special chars except '.', spaces)
    if (!this.validPattern.test(value)) {
      return { invalidCharacters: 'Only numbers and a single decimal point are allowed. No letters, special characters, or spaces.' };
    }

    // Check for multiple decimal points
    if ((value.match(/\./g) || []).length > 1) {
      return { multipleDecimals: 'Only one decimal point is allowed.' };
    }

    // Check for URL-like input
    if (this.urlPattern.test(value)) {
      return { invalidUrl: 'URLs are not allowed. Please enter a valid number.' };
    }

    // Check for zero or equivalent (0, 0.0, 0.00, etc.)
    const numericValue = parseFloat(value);
    if (numericValue === 0) {
      return { zeroValue: 'Amount cannot be zero or equivalent (e.g., 0, 0.0, 0.00).' };
    }

    return null;
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    // Prevent invalid characters in real-time
    const lastValidValue = input.value;
    input.value = value.replace(/[^0-9.]/g, '');

    // Ensure only one decimal point
    const parts = input.value.split('.');
    if (parts.length > 2) {
      input.value = `${parts[0]}.${parts[1]}`;
    }

    // Trigger change detection if value was modified
    if (input.value !== lastValidValue) {
      input.dispatchEvent(new Event('input'));
    }
  }
}